document.addEventListener('DOMContentLoaded', function () {
  // Find the shipping widget(s)
  var shippingBlocks = document.querySelectorAll(
    'pdp-shipping-decimal.product-shipping'
  );

  if (!shippingBlocks.length) return;

  shippingBlocks.forEach(function (block) {
    // Scope: main product area around this shipping block
    var scope =
      block.closest('section, .product, .product-main, .product__info') ||
      document.body;

    var scopeText = (scope.textContent || '').toLowerCase();

    // Condition 1: Estimated Ship Date text present
    var hasEstimatedShipDate = scopeText.includes('estimated ship date:');

    // Condition 2: real "Sold out" button (not just text somewhere)
    var hasSoldOutButton = false;

    // Try to find the product form in this scope
    var productForm =
      scope.querySelector('form[action*="/cart"]') ||
      scope.querySelector('form[class*="product-form"], form[id*="product"]');

    if (productForm) {
      var btn =
        productForm.querySelector(
          'button[type="submit"], button[name="add"], button, input[type="submit"]'
        );

      if (btn) {
        var btnText = (btn.textContent || btn.value || '').toLowerCase();
        if (btnText.includes('sold out')) {
          hasSoldOutButton = true;
        }
      }
    }

    // OR logic: hide shipping if Est. Ship Date OR Sold-out button
    if (hasEstimatedShipDate || hasSoldOutButton) {
      block.style.display = 'none';
    }
  });
});
